import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/empty_img.svg'


const _withScopeId = n => (_pushScopeId("data-v-3ce06329"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "nav_type5" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 2,
  src: _imports_0
}

import { ref, withDefaults, watch } from 'vue';
import emitter from '@/utils/mitt';

interface Props {
  component: any;
  Index: number;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'cubeNav',
  props: {
    component: { default: Object },
    Index: { default: null }
  },
  setup(__props: any) {

const props = __props as { component: any, Index: number };


watch(props.component.content, () => {
  selectNavItem.value = 7;
});
const radius = ref(['50%', '8px', '0px', '0']);
const modalType = ref();
const navIndex = ref();
const selectNavItem = ref<any>();
const changeSel = (key: number) => {
  key != 7 && (navIndex.value != props.Index || modalType.value != 1)
    ? (emitter.emit('modalIndex', props.Index), (selectNavItem.value = 7))
    : (selectNavItem.value = key);
  emitter.emit('selectNavItem', selectNavItem.value);
};
emitter.on('cubnavInfo', (e: any) => {
  modalType.value = e.type;
  navIndex.value = e.index;
  e.type != 1 || e.index != props.Index ? (selectNavItem.value = 7) : '';
});
emitter.on('changeNavType', (e: any) => {
  changeSel(e);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "nav_box flex wrap",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (changeSel(7)))
  }, [
    _createElementVNode("div", {
      class: "flex wrap",
      style: _normalizeStyle({ width: props.component.content.navType != 4 && props.component.content.navType != 5 ? '100%' : '' })
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.component.navList, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["item_box", {
          active_border:
            props.component.content.navType != 5
              ? selectNavItem.value == index
              : selectNavItem.value == 0
              ? index == 0 || index == 2
              : selectNavItem.value == index,
        }]),
          key: index,
          onClick: _withModifiers(($event: any) => (changeSel(index)), ["stop"]),
          style: _normalizeStyle({
          width: props.component.content.navType != 4 && props.component.content.navType != 5 ? '20%' : '',
          borderTop: props.component.content.navType == 5 && selectNavItem.value == 0 && index == 2 ? '2px dashed #fff' : '',
          borderBottom: props.component.content.navType == 5 && selectNavItem.value == 0 && index == 0 ? '2px dashed #fff' : '',
        })
        }, [
          _withDirectives(_createElementVNode("div", {
            class: _normalizeClass(["nav_item flex center", {
            nav_Type2: props.component.content.navType == 2,
            nav_Type4: props.component.content.navType == 4,
            between: props.component.content.navType == 4,
          }]),
            style: _normalizeStyle({
            borderRadius: radius.value[props.component.content.radius_type],
            background: item.bg_type == 2 ? item.bg_color : item.bg_type == 1 ? 'transparent' : item.default_bg_color,
            backgroundImage: item.bg_type == 2 ? `url(${item.bg_img})` : item.default_bg_color,
          })
          }, [
            _withDirectives(_createElementVNode("span", {
              class: "title_height",
              style: _normalizeStyle({
              color: props.component.content.title_color,
            })
            }, _toDisplayString(item.title_type == 0 && item.title ? item.title.slice(0, 4) : ''), 5), [
              [_vShow, props.component.content.navType == 4]
            ]),
            (item.icon && !item.icon.includes('https'))
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "flex center",
                  innerHTML: item.icon
                }, null, 8, _hoisted_2))
              : (item.icon && item.icon_type != 1)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: item.icon,
                    alt: ""
                  }, null, 8, _hoisted_3))
                : (item.icon_type != 1)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 2,
                      style: _normalizeStyle({ background: props.component.content.navType ? '#DCDFE6' : '' }),
                      src: _imports_0
                    }, null, 4))
                  : _createCommentVNode("", true)
          ], 6), [
            [_vShow, props.component.content.navType != 5]
          ]),
          _withDirectives(_createElementVNode("p", {
            class: "title_height",
            style: _normalizeStyle({
            color:
              props.component.content.title_type == 1
                ? props.component.content.title_color
                : props.component.content.title_default_color,
          })
          }, _toDisplayString(item.title_type == 0 && item.title ? item.title.slice(0, 4) : ''), 5), [
            [_vShow, props.component.content.navType != 4 && props.component.content.navType != 5]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: _normalizeClass(["item flex between", { itemOne: index == 0 }]),
              style: _normalizeStyle({
              borderRadius: radius.value[props.component.content.radius_type],
              background: item.bg_type == 2 ? item.bg_color : item.bg_type == 1 ? 'transparent' : item.default_bg_color,
              backgroundImage: item.bg_type == 2 ? `url(${item.bg_img})` : item.default_bg_color,
            })
            }, [
              _createElementVNode("span", {
                class: "title_height",
                style: _normalizeStyle({
                color: props.component.content.title_color,
              })
              }, _toDisplayString(item.title_type == 0 && item.title ? item.title.slice(0, 4) : ''), 5),
              (item.icon && !item.icon.includes('https'))
                ? (_openBlock(), _createElementBlock("p", {
                    key: 0,
                    class: "flex center",
                    innerHTML: item.icon
                  }, null, 8, _hoisted_5))
                : (item.icon && item.icon_type != 1)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: item.icon,
                      alt: ""
                    }, null, 8, _hoisted_6))
                  : (item.icon_type != 1)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_7))
                    : _createCommentVNode("", true)
            ], 6)
          ], 512), [
            [_vShow, props.component.content.navType == 5]
          ])
        ], 14, _hoisted_1))
      }), 128))
    ], 4)
  ]))
}
}

})